(function () {
  'use strict';

  const source = window.BCFFamilyCatalog;
  const mount = document.querySelector('[data-bcf-chain-finder]');
  if (!source || !mount) return;

  const familyMeta = {
    rope: { description: 'Textured +\ndimensional', construction: 'Textured rope construction. More millimeters means more silver and stronger presence.', card: 'bcf-finder-rope-card-v1.jpg' },
    curb: { description: 'Clean + flatter\nprofile', construction: 'Same flat curb construction. More millimeters means wider links, more metal and stronger presence.', card: 'bcf-finder-curb-card-v1.jpg' },
    figaro: { description: 'Distinct\nalternating links', construction: 'Same flat Figaro construction. More millimeters means wider links, more metal and stronger presence.', card: 'bcf-finder-figaro-card-v1.jpg' }
  };
  const shortRole = function (label) { return String(label).replace(/\s+(Rope|Curb|Figaro)$/i, ''); };
  const catalog = Object.fromEntries(Object.entries(source.families).map(function (entry) {
    const key = entry[0];
    const family = entry[1];
    return [key, {
      label: family.label,
      description: familyMeta[key].description,
      construction: familyMeta[key].construction,
      cardImage: source.assetBase + familyMeta[key].card,
      url: family.url,
      defaultCode: family.defaultWidth,
      series: Object.entries(family.widths).map(function (widthEntry) {
        const code = widthEntry[0];
        const item = widthEntry[1];
        const weights = {};
        const prices = {};
        source.lengths.forEach(function (length) {
          const variant = item.variants[length];
          weights[length] = variant.grams;
          prices[length] = [variant.price, variant.compare];
        });
        return { code: code, width: item.mm, role: shortRole(item.role), weights: weights, prices: prices, variants: item.variants };
      })
    }];
  }));

  const params = new URLSearchParams(window.location.search);
  const initialFamily = catalog[params.get('family')] ? params.get('family') : 'rope';
  const initialSeries = catalog[initialFamily].series.some(function (item) { return item.code === params.get('width'); }) ? params.get('width') : catalog[initialFamily].defaultCode;
  const initialLength = source.lengths.includes(Number(params.get('length'))) ? Number(params.get('length')) : 20;
  const state = { step: 'style', family: initialFamily, seriesCode: initialSeries, length: initialLength };

  const $ = function (id) { return document.getElementById(id); };
  const els = {
    fitPreview: $('fitPreview'), previewImage: $('previewImage'), previewCaption: $('previewCaption'), previewHelper: $('previewHelper'),
    referenceLabel: $('referenceLabel'), stepCount: $('stepCount'), heroTitle: $('heroTitle'), heroCopy: $('heroCopy'), sectionKicker: $('sectionKicker'),
    sectionTitle: $('sectionTitle'), sectionCopy: $('sectionCopy'), choiceArea: $('choiceArea'), primaryAction: $('primaryAction'), footerNote: $('footerNote'),
    backButton: $('backButton'), bagButton: $('bagButton'), toast: $('toast'),
    cartConfirmation: $('cartConfirmation'), cartConfirmationClose: $('cartConfirmationClose'),
    cartConfirmationImage: $('cartConfirmationImage'), cartConfirmationSelection: $('cartConfirmationSelection'),
    cartConfirmationPrice: $('cartConfirmationPrice'), finderCheckoutForm: $('finderCheckoutForm'),
    finderCheckoutButton: $('finderCheckoutButton'), finderSecondChain: $('finderSecondChain')
  };
  const family = function () { return catalog[state.family]; };
  const series = function () { return family().series.find(function (item) { return item.code === state.seriesCode; }) || family().series[0]; };
  const variant = function () { return series().variants[state.length]; };
  const money = function (value) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: value % 1 ? 2 : 0 }).format(value); };
  const moneyFromCents = function (value) { return money((Number(value) || 0) / 100); };

  function eventId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return `${prefix}-${window.crypto.randomUUID()}`;
    return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  }

  function imageForState(length, item) { return `${source.assetBase}bcf-fit-${state.family}-${item.code}-${item.width.toFixed(1)}mm-${length}in-v1.jpg`; }
  function setImage(src) {
    if (els.previewImage.getAttribute('src') === src) {
      if (els.previewImage.complete && els.previewImage.naturalWidth) els.fitPreview.classList.remove('is-loading');
      return;
    }
    els.fitPreview.classList.add('is-loading');
    els.previewImage.onload = function () { els.fitPreview.classList.remove('is-loading'); };
    els.previewImage.onerror = function () { els.fitPreview.classList.remove('is-loading'); };
    els.previewImage.src = src;
  }
  function renderPreview() {
    const item = series();
    const length = state.length;
    setImage(imageForState(length, item));
    els.referenceLabel.textContent = `${length}\" fit`;
    els.previewImage.alt = `${family().label} ${item.code}, ${item.width.toFixed(1)} millimeter, ${length} inch fit reference`;
    els.previewHelper.innerHTML = 'Individual fit image<br>for this exact choice';
    els.previewCaption.innerHTML = state.step === 'style' ? `${family().label}<br>${item.role} · ${length}\"` : `${family().label} ${item.code}<br>${item.width.toFixed(1)} mm · ${length}\"`;
  }
  function confirmPreviewUpdate() {
    els.fitPreview.classList.remove('preview-confirm');
    requestAnimationFrame(function () { els.fitPreview.classList.add('preview-confirm'); });
    setTimeout(function () { els.fitPreview.classList.remove('preview-confirm'); }, 760);
  }
  function syncUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('family', state.family); url.searchParams.set('width', state.seriesCode); url.searchParams.set('length', String(state.length));
    window.history.replaceState({}, '', url.toString());
  }
  function styleCard(key) {
    const item = catalog[key];
    const selected = state.family === key;
    const button = document.createElement('button');
    button.type = 'button'; button.className = `style-card ${key}-card`; button.setAttribute('aria-pressed', String(selected));
    button.innerHTML = `<img src="${item.cardImage}" alt="${item.label} link pattern"><span class="style-card-copy"><span class="style-card-title"><span>${item.label.toUpperCase()}</span><span>${selected ? '✓' : ''}</span></span><span class="style-card-description">${item.description.replace('\n', '<br>')}</span></span>`;
    button.addEventListener('click', function () { state.family = key; state.seriesCode = catalog[key].defaultCode; state.length = 20; render(); confirmPreviewUpdate(); });
    return button;
  }
  function renderStyle() {
    const container = document.createElement('div'); container.className = 'style-cards';
    ['rope', 'curb', 'figaro'].forEach(function (key) { container.append(styleCard(key)); });
    els.choiceArea.replaceChildren(container);
  }
  function widthRow(item) {
    const selected = item.code === state.seriesCode;
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'ledger-row'; button.setAttribute('aria-pressed', String(selected));
    button.innerHTML = `<strong class="col-code">${item.code}</strong><span class="col-width">${item.width.toFixed(1)} mm</span><span class="col-weight">${item.weights[20].toFixed(1)} g</span><span class="row-action">${selected ? '✓' : item.role.toUpperCase()}</span>`;
    button.addEventListener('click', function () { state.seriesCode = item.code; render(); confirmPreviewUpdate(); });
    return button;
  }
  function renderWidth() {
    const ledger = document.createElement('div'); ledger.className = 'ledger width-ledger';
    ledger.innerHTML = '<div class="ledger-head"><span class="col-code">Series</span><span class="col-width">Width</span><span class="col-weight">20 in weight</span></div>';
    family().series.forEach(function (item) { ledger.append(widthRow(item)); }); els.choiceArea.replaceChildren(ledger);
  }
  function lengthRow(length) {
    const selected = state.length === length;
    const prices = series().prices[length];
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'ledger-row'; button.setAttribute('aria-pressed', String(selected));
    button.innerHTML = `<strong class="col-length">${length} in</strong><span class="col-weight">${series().weights[length].toFixed(1)} g</span><span class="col-price"><span class="regular-price">${money(prices[1])}</span><span class="summer-price">${money(prices[0])}</span></span><span class="row-action">${selected ? '✓' : 'Select'}</span>`;
    button.addEventListener('click', function () { state.length = length; render(); confirmPreviewUpdate(); });
    return button;
  }
  function renderLength() {
    const ledger = document.createElement('div'); ledger.className = 'ledger length-ledger';
    ledger.innerHTML = '<div class="ledger-head"><span class="col-length">Length</span><span class="col-weight">Weight</span><span class="col-price">Summer</span></div>';
    source.lengths.forEach(function (length) { ledger.append(lengthRow(length)); }); els.choiceArea.replaceChildren(ledger);
  }
  function renderMatch() {
    const item = series(); const prices = item.prices[state.length]; const ledger = document.createElement('div'); ledger.className = 'ledger match-ledger';
    ledger.innerHTML = `<div class="match-price-head"><span class="match-sku">${family().label} ${item.code} · ${state.length} in</span><span class="match-price"><span class="regular-price">${money(prices[1])}</span><strong>${money(prices[0])}</strong></span></div><div class="spec-row"><span>Width</span><strong>${item.width.toFixed(1)} mm</strong></div><div class="spec-row"><span>Listed weight</span><strong>${item.weights[state.length].toFixed(1)} g</strong></div><div class="spec-row"><span>Material</span><strong>925 sterling silver</strong></div><div class="spec-row"><span>Finish</span><strong>High polish</strong></div>`;
    els.choiceArea.replaceChildren(ledger);
  }
  function renderText() {
    const item = series();
    const presence = state.family === 'curb' ? `a flat ${item.width.toFixed(1)} mm presence` : state.family === 'figaro' ? `an alternating ${item.width.toFixed(1)} mm presence` : `a dimensional ${item.width.toFixed(1)} mm presence`;
    const content = {
      style: { count: '01 / 03', hero: 'Build your chain.<br>See every choice.', copy: 'Choose the style, presence and length. See each decision change the chain before you order.', kicker: '01 · Style', title: 'Which chain style do you like?', sectionCopy: 'Look at the link structure—not a tiny icon.', action: 'Continue to presence', note: 'Fit placement is a visual guide; neck and body proportions can shift where a chain rests.' },
      width: { count: '02 / 03', hero: 'Choose your width.<br>See the difference.', copy: family().construction, kicker: '02 · Width', title: 'How much presence do you want?', sectionCopy: 'Compare the exact series, width and selected-length weight.', action: 'Continue to length', note: 'Weights and prices come from the current product record.' },
      length: { count: '03 / 03', hero: 'Choose your length.<br>Finish the fit.', copy: 'Each length uses its own on-body image. Your selected millimeter gauge stays unchanged.', kicker: '03 · Length', title: 'Where should it land?', sectionCopy: 'Four individual fit images for every exact width.', action: 'View your match', note: 'Fit placement is a visual guide; neck and body proportions can shift where a chain rests.' },
      match: { count: 'Your match', hero: 'Your chain,<br>resolved.', copy: `${family().label} ${item.code} gives ${presence} at a versatile ${state.length}-inch placement.`, kicker: 'Selected chain', title: `${family().label} ${item.code} · ${item.width.toFixed(1)} mm · ${state.length} in`, sectionCopy: 'Solid 925 · high polish · listed weight', action: 'Add selected chain', note: 'The crossed-out price is the current compare-at price; the lower price is applied before the second-chain discount.' }
    }[state.step];
    els.stepCount.textContent = content.count; els.heroTitle.innerHTML = content.hero; els.heroCopy.textContent = content.copy; els.sectionKicker.textContent = content.kicker;
    els.sectionTitle.textContent = content.title; els.sectionCopy.textContent = content.sectionCopy; els.primaryAction.firstElementChild.textContent = content.action; els.footerNote.textContent = content.note;
  }
  function render() {
    renderText(); renderPreview();
    if (state.step === 'style') renderStyle(); if (state.step === 'width') renderWidth(); if (state.step === 'length') renderLength(); if (state.step === 'match') renderMatch();
    syncUrl();
  }
  function toast(message) {
    els.toast.textContent = message; els.toast.hidden = false; window.clearTimeout(toast.timer); toast.timer = window.setTimeout(function () { els.toast.hidden = true; }, 3200);
  }
  function checkoutItems(cart) {
    return (cart.items || []).map(function (item) {
      return {
        variant_id: item.variant_id || item.id,
        product_id: item.product_id,
        title: item.product_title || item.title || '',
        variant_title: item.variant_title || '',
        quantity: Number(item.quantity) || 1,
        price: Number(item.final_price || item.price) || 0
      };
    });
  }
  function cartSignature(cart) {
    const lines = (cart.items || []).map(function (item) { return `${item.variant_id || item.id}:${item.quantity}:`; }).join('');
    return `${lines}${cart.total_price || 0}`;
  }
  function dispatchCanonicalAdd(cartBefore, cartAfter, selected) {
    const selectedId = String(selected.id);
    const line = (cartAfter.items || []).find(function (item) { return String(item.id) === selectedId; }) || {};
    const itemCountBefore = Number(cartBefore && cartBefore.item_count);
    const safeItemCountBefore = Number.isFinite(itemCountBefore) ? itemCountBefore : Math.max(0, (Number(cartAfter.item_count) || 0) - 1);
    const itemCountAfter = Number(cartAfter.item_count) || 0;
    const isFirstCartBuild = safeItemCountBefore === 0 && itemCountAfter > 0;
    const atcActionId = eventId('bcf-finder-atc');
    const cartBuildId = isFirstCartBuild ? eventId('bcf-finder-cart-build') : '';
    document.dispatchEvent(new CustomEvent('bcf:add-to-cart', {
      detail: {
        atcActionId: atcActionId,
        cartBuildId: cartBuildId,
        isFirstCartBuild: isFirstCartBuild,
        itemCountBefore: safeItemCountBefore,
        itemCountAfter: itemCountAfter,
        variantId: selectedId,
        quantity: 1,
        totalQuantity: 1,
        item: line,
        items: [line]
      }
    }));
    return line;
  }
  function showConfirmation(cart, line) {
    const item = series();
    const selection = `${family().label} ${item.code} · ${item.width.toFixed(1)} mm · ${state.length} in`;
    els.cartConfirmationImage.src = els.previewImage.src;
    els.cartConfirmationImage.alt = `${selection} fit preview`;
    els.cartConfirmationSelection.textContent = selection;
    els.cartConfirmationPrice.textContent = moneyFromCents(line.final_line_price || line.line_price || line.price || variant().price * 100);
    els.finderCheckoutButton.textContent = `Checkout securely · ${moneyFromCents(cart.total_price)}`;
    els.finderCheckoutForm.dataset.bcfCheckoutItemCount = String(cart.item_count || 0);
    els.finderCheckoutForm.dataset.bcfCheckoutValue = String(cart.total_price || 0);
    els.finderCheckoutForm.dataset.bcfCheckoutCurrency = cart.currency || 'USD';
    els.finderCheckoutForm.dataset.bcfCheckoutSignature = cartSignature(cart);
    els.finderCheckoutForm.dataset.bcfCheckoutItems = JSON.stringify(checkoutItems(cart));
    els.cartConfirmation.hidden = false;
    document.documentElement.classList.add('finder-confirmation-open');
    window.setTimeout(function () { els.finderCheckoutButton.focus(); }, 30);
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture('finder_cart_confirmation_viewed', {
        family: state.family,
        width_code: item.code,
        width_mm: item.width,
        length_in: state.length,
        variant_id: String(variant().id),
        cart_total: (Number(cart.total_price) || 0) / 100,
        cart_item_count: Number(cart.item_count) || 0
      });
    }
  }
  function hideConfirmation() {
    els.cartConfirmation.hidden = true;
    document.documentElement.classList.remove('finder-confirmation-open');
    els.primaryAction.focus();
  }
  async function addSelected() {
    const selected = variant();
    if (!selected || !selected.available) { toast('That selection is not currently available.'); return; }
    els.primaryAction.disabled = true;
    try {
      let cartBefore = null;
      try {
        const beforeResponse = await fetch('/cart.js', { headers: { accept: 'application/json' } });
        if (beforeResponse.ok) cartBefore = await beforeResponse.json();
      } catch (error) {}
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(selected.id), quantity: 1 }] }) });
      if (!response.ok) throw new Error(`Cart returned ${response.status}`);
      const cartResponse = await fetch('/cart.js', { headers: { accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(`Cart read returned ${cartResponse.status}`);
      const cartAfter = await cartResponse.json();
      const line = dispatchCanonicalAdd(cartBefore, cartAfter, selected);
      showConfirmation(cartAfter, line);
      els.primaryAction.disabled = false;
    } catch (error) {
      els.primaryAction.disabled = false; toast('We could not add that chain. Please try again.');
    }
  }

  els.primaryAction.addEventListener('click', function () {
    if (state.step === 'style') state.step = 'width'; else if (state.step === 'width') state.step = 'length'; else if (state.step === 'length') state.step = 'match'; else { addSelected(); return; }
    render(); window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  els.backButton.addEventListener('click', function () {
    if (state.step === 'match') state.step = 'length'; else if (state.step === 'length') state.step = 'width'; else if (state.step === 'width') state.step = 'style'; else { window.location.assign('/'); return; }
    render(); window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  els.bagButton.addEventListener('click', function () { window.location.assign('/cart'); });
  els.cartConfirmationClose.addEventListener('click', hideConfirmation);
  els.finderSecondChain.addEventListener('click', function () {
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture('finder_second_chain_clicked');
    hideConfirmation(); state.step = 'style'; render(); window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !els.cartConfirmation.hidden) hideConfirmation();
  });
  els.previewImage.addEventListener('load', function () { els.fitPreview.classList.remove('is-loading'); });
  render();
})();
